import { createFileRoute } from '@tanstack/react-router'
import { TrainingProgramDetail } from '@/components/employee-center/TrainingProgramDetail'
import { useEmployeeCenterDashboard } from '@/components/employee-center/EmployeeCenterEmployeeShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/training_/$programId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { programId } = Route.useParams()
  const { dashboard } = useEmployeeCenterDashboard()

  const trainingRecord =
    dashboard.trainingRecords.find((r) => r.programId === programId) ?? null

  return (
    <TrainingProgramDetail
      programId={programId}
      trainingRecord={trainingRecord}
    />
  )
}
